var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{attrs:{"role":"banner"}},[_c('div',{staticClass:"layout"},[_c('h1',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("EmojiSpell")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }